import { SubscriptionPaymentMethod } from "features/payment-methods/components";
import type { MixpanelPaymentMethodSource } from "features/payment-methods/types";

import { Dialog, DialogContent } from "common/components/ui/Dialog";
import { Drawer, DrawerContent } from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import type { ComponentProps } from "react";

interface PaymentMethodModalProps
  extends Omit<
    ComponentProps<typeof SubscriptionPaymentMethod>,
    "onBack" | "onSuccess"
  > {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  mixpanelSource: MixpanelPaymentMethodSource;
}

export default function SubscriptionPaymentMethodModal({
  subscriptionId,
  isOpen,
  setIsOpen,
  initialPaymentSource,
  mixpanelSource,
}: PaymentMethodModalProps) {
  const isDesktop = useTwBreakpoint("lg");

  const Component = isDesktop ? Dialog : Drawer;
  const Content = isDesktop ? DialogContent : DrawerContent;

  return (
    <Component open={isOpen} onOpenChange={setIsOpen}>
      <Content>
        <SubscriptionPaymentMethod
          subscriptionId={subscriptionId}
          initialPaymentSource={initialPaymentSource}
          onBack={() => setIsOpen(false)}
          onSuccess={() => setIsOpen(false)}
          mixpanelSource={mixpanelSource}
        />
      </Content>
    </Component>
  );
}
